import { useEffect, useState } from 'react';
import Button from '~/src/components/LandingBlock/Common/Button';
import { prepareBlockColumns, prepareColumnStyles } from '~/src/services/blocks/prepareBlocks';
import { INormalizedLandingElement } from '~/src/services/projects';
import { ImagePlaceholder } from '~/src/components/LandingBlock/styled';
import { IMG_DOMAIN } from '~/src/services/blocks/templates';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import * as ST from './styled';

interface IGridProps {
    blockId: string;
    columns: INormalizedLandingElement;
    customStyles: any;
    isAdmin?: boolean;
    currentBreakpoint?: string;
    background?: string;
    additionalBlockConfig?: any;
}

const BlockGrid = ({
    blockId,
    columns,
    customStyles,
    isAdmin,
    currentBreakpoint,
    background,
    additionalBlockConfig,
}: IGridProps): JSX.Element => {

    const [items, setItems] = useState([]);

    useEffect(() => {
        if (Object.keys(columns).length == 0) return;
        const root = Object.keys(columns).shift().split('.').shift().match(/\w+/g)[0];
        const preparedColumns = prepareBlockColumns(columns, 'BlockGridColumn', customStyles);
        if (preparedColumns[root] !== undefined) {
            setItems(prepareColumnStyles(preparedColumns[root], customStyles));
        }
    }, [columns, currentBreakpoint, customStyles]);

    return (
        <ST.Wrapper id={blockId} {...customStyles} background={background} {...additionalBlockConfig}>
            <ST.StyledGrid>
                    <ST.Row>
                        {
                            items?.map((item) => (
                                <ST.Col key={item.id} sm={+item.properties.width} xs={12} id={item.scrollId}>
                                    <ST.ColWrapper
                                        backgroundColor={item.properties.backgroundColor}
                                        backgroundImage={item.properties.background}
                                        borderRadius={item.properties.borderRadius}
                                        padding={{
                                            horizontal: item.properties.paddingHorizontal,
                                            vertical: item.properties.paddingVertical,
                                        }}
                                        imagePlacement={item.Image.properties.customize.placement}
                                        {...item.customStyles}
                                    >
                                        <ST.ImageWrapper
                                            imagePlacement={item.Image.properties.customize.placement}
                                            {...item.customStyles}
                                        >
                                            <ST.IconWrapper>
                                                <ST.Icon {...item.customStyles}>
                                                    {item.Image.properties.content
                                                        ? <WebpImage urlWebp={item.Image.properties.webp && `${IMG_DOMAIN}${item.Image.properties.webp}`}>
                                                            <img src={`${IMG_DOMAIN}${item.Image.properties.content}`} alt={item.Image.properties.alt}/>
                                                        </WebpImage>
                                                        : <ImagePlaceholder width={66} height={66} isAdmin={isAdmin}/>
                                                    }
                                                </ST.Icon>
                                            </ST.IconWrapper>
                                        </ST.ImageWrapper>
                                        <ST.TextWrapper>
                                            <ST.Title
                                                {...item.customStyles}
                                                dangerouslySetInnerHTML={{ __html: item.Title.properties.htmlContent }}
                                            />
                                            <ST.Text
                                                {...item.customStyles}
                                                dangerouslySetInnerHTML={{ __html: item.Text.properties.htmlContent }}
                                            />
                                            <Button
                                                elemId={`${blockId}.button`}
                                                href={item.Button.properties.href}
                                                isTargetBlank={item.Button.properties.isTargetBlank}
                                                idForScroll={item.Button.properties.idForScroll}
                                                analytics={item.Button.properties.analytics}
                                                buttonText={item.Button.Text.properties.content}
                                                backgroundColor={item.Button.properties.backgroundColor}
                                                backgroundHoverColor={item.Button.properties.backgroundHoverColor}
                                                customStyles={item.customStyles}
                                                align={item.Button.properties.textAlign}
                                                isAutoWidth={true}
                                                enableCalltouch={item.Button.properties.enableCalltouch}
                                            />
                                        </ST.TextWrapper>
                                    </ST.ColWrapper>
                                </ST.Col>
                            ))
                        }
                    </ST.Row>
            </ST.StyledGrid>
        </ST.Wrapper>
    );
};

export default BlockGrid;
